import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: theme.spacing(1),
    boxShadow: "-2px 2px 4px 0px rgba(0, 0, 0, 0.15)",
    overflowY: "auto",
    maxHeight: "80vh",
    // minHeight: "80vh",
    position: "absolute",
    width: "50%",
  },
  inputLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#8F8F8F",
    marginLeft: theme.spacing(1),
  },
  input: {
    borderRadius: theme.spacing(1),
  },
  button: {
    width: theme.spacing(21),
    height: theme.spacing(5),
    textTransform: "uppercase",
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
  },
  deleteButton: {
    backgroundColor: "#EB5757",
    color: "white",
    "&:hover": {
      backgroundColor: "#EB5757",
      color: "white",
      opacity: 0.6,
    },
  },
}));

export default useStyles;
